import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLevels, fetchStudents } from "../studentSlice";

import StudentCreateModal from "./StudentCreateModal";
import LevelList from "./LevelList/LevelList";
import StudentTable from "./StudentTable/StudentTable";
import StudentSearchBar from "./StudentSearchBar";
import ManyStudentCreateModal from "./ManyStudentCreateModal";
import GradeIncreaseButton from "./GradeIncreaseButton";

import { filterStudentsByKeyword } from "../studentSlice";

const StudentManagementPage = () => {
  const dispatch = useDispatch();
  const { levels, filteredStudents, loading } = useSelector(
    (state) => state.student
  );
  const [isStudentModalOpen, setIsStudentModalOpen] = useState(false);
  const [isManyStudentModalOpen, setIsManyStudentModalOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [studentList, setStudentList] = useState([]);

  const handleFiltering = () => {
    dispatch(filterStudentsByKeyword(keyword));
  };

  useEffect(() => {
    dispatch(fetchLevels());
    dispatch(fetchStudents());
  }, [dispatch]);

  useEffect(() => {
    setStudentList(filteredStudents);
  }, [filteredStudents]);

  return (
    <div className="page-container">
      <div
        style={{
          display: "grid",
          gridTemplateColumns: Math.min(window.innerWidth, window.screen.width) <= 768 ? "1fr" : "auto 1fr auto",
          alignItems: Math.min(window.innerWidth, window.screen.width) <= 768 ? "stretch" : "center",
          columnGap: Math.min(window.innerWidth, window.screen.width) <= 768 ? 0 : "20px",
          rowGap: Math.min(window.innerWidth, window.screen.width) <= 768 ? "10px" : 0,
          padding: "5px 0",
        }}
      >
        {/* 1열: 첫 요소 (왼쪽 끝 고정) */}
        <div className="section-title">재원생 관리</div>

        {/* 2열: 중간 영역 (여백) */}
        <div />

        {/* 3열: 검색 + 버튼 (오른쪽 끝 고정) */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: Math.min(window.innerWidth, window.screen.width) <= 768 ? "6px" : "10px",
            justifyContent: Math.min(window.innerWidth, window.screen.width) <= 768 ? "stretch" : "flex-end",
            flexWrap: "wrap",
          }}
        >
          <div style={{ minWidth: Math.min(window.innerWidth, window.screen.width) <= 768 ? 0 : "220px", flex: Math.min(window.innerWidth, window.screen.width) <= 768 ? 1 : "none" }}>
            <StudentSearchBar
              handleFilter={handleFiltering}
              keyword={keyword}
              setKeyword={setKeyword}
            />
          </div>
          <button
            style={{
              padding: Math.min(window.innerWidth, window.screen.width) <= 768 ? "8px 12px" : "10px 20px",
              backgroundColor: "#0E141B",
              color: "#FFF",
              border: "none",
              borderRadius: "999px",
              cursor: "pointer",
              fontSize: "0.86rem",
              fontWeight: 700,
              fontFamily: "inherit",
              whiteSpace: "nowrap",
              transition: "background-color .12s",
            }}
            onClick={() => setIsStudentModalOpen(true)}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#00A396")}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#0E141B")}
          >
            + 학생 등록
          </button>
          <button
            style={{
              padding: Math.min(window.innerWidth, window.screen.width) <= 768 ? "8px 12px" : "10px 18px",
              backgroundColor: "#F4F8F7",
              color: "#3A434E",
              border: "none",
              borderRadius: "999px",
              cursor: "pointer",
              fontSize: "0.86rem",
              fontWeight: 700,
              fontFamily: "inherit",
              whiteSpace: "nowrap",
              transition: "background-color .12s, color .12s",
            }}
            onClick={() => setIsManyStudentModalOpen(true)}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#E5FBF8";
              e.currentTarget.style.color = "#00A396";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#F4F8F7";
              e.currentTarget.style.color = "#3A434E";
            }}
          >
            + 학생 대량 등록
          </button>
          <GradeIncreaseButton />
        </div>
      </div>

      <div
        style={{
          padding: "0px",
          display: "flex",
          // [모바일 수정] 반 목록을 표 위로 쌓기 — 표 압착으로 글자가 세로로
          // 붕괴하던 원인 제거. 세로 스택에선 높이 제한도 해제.
          flexDirection: Math.min(window.innerWidth, window.screen.width) <= 768 ? "column" : "row",
          justifyContent: "center",
          alignItems: "stretch",
          maxHeight: Math.min(window.innerWidth, window.screen.width) <= 768 ? "none" : "calc(100vh - 200px)",
          gap: Math.min(window.innerWidth, window.screen.width) <= 768 ? "12px" : 0,
        }}
      >
        {loading && <div></div>}

        <LevelList
          levels={levels}
          allStudentList={filteredStudents}
          setIsStudentModalOpen={setIsStudentModalOpen}
          setStudentList={setStudentList}
          studentList={studentList}
        />

        <StudentTable students={studentList}></StudentTable>

        {isStudentModalOpen && (
          <StudentCreateModal setIsStudentModalOpen={setIsStudentModalOpen} />
        )}
        {isManyStudentModalOpen && (
          <ManyStudentCreateModal
            setIsManyStudentModalOpen={setIsManyStudentModalOpen}
          />
        )}
      </div>
    </div>
  );
};

export default StudentManagementPage;
